import { call, put, takeLatest, all } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_PARTENAIRES_ACAD_REQUEST,
    fetchPartenairesAcadSuccess,
    fetchPartenairesAcadFail,

    CREATE_PARTENAIRE_ACAD_REQUEST,
    createPartenaireAcadSuccess,
    createPartenaireAcadFail,

    UPDATE_PARTENAIRE_ACAD_REQUEST,
    updatePartenaireAcadSuccess,
    updatePartenaireAcadFail,

    DELETE_PARTENAIRE_ACAD_REQUEST,
    deletePartenaireAcadSuccess,
    deletePartenaireAcadFail,

    setPartenairesAcadLoading,
} from "../actions/partenairesAcademiquesActions";

// ✅ Comme ton loginSaga : api.js est dans src/api.js
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function buildPartenaireAcadFormData(payload) {
    const fd = new FormData();

    const imageFile = payload?.imageFile || null;

    const clean = { ...payload };
    delete clean.imageFile;

    fd.append("payload", JSON.stringify(clean));
    if (imageFile) fd.append("image", imageFile);

    return fd;
}

export function* fetchPartenairesAcadSaga() {
    const url = `${API_BASE_URL}/api/partenaires-academiques`;
    const uid = getUid();
    const token = getToken();

    yield put(setPartenairesAcadLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchPartenairesAcadSuccess(resp.data));
    } catch (e) {
        yield put(fetchPartenairesAcadFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setPartenairesAcadLoading(false));
    }
}

export function* createPartenaireAcadSaga(action) {
    const url = `${API_BASE_URL}/api/partenaires-academiques`;
    const uid = getUid();
    const token = getToken();

    yield put(setPartenairesAcadLoading(true));
    try {
        const fd = buildPartenaireAcadFormData(action.payload);

        const resp = yield call(postRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(createPartenaireAcadSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Partenaire académique ajouté",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_PARTENAIRES_ACAD_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout partenaire";
        yield put(createPartenaireAcadFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setPartenairesAcadLoading(false));
    }
}

export function* updatePartenaireAcadSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/partenaires-academiques/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setPartenairesAcadLoading(true));
    try {
        const fd = buildPartenaireAcadFormData(payload);

        const resp = yield call(putRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(updatePartenaireAcadSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Partenaire académique modifié",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_PARTENAIRES_ACAD_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification partenaire";
        yield put(updatePartenaireAcadFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setPartenairesAcadLoading(false));
    }
}

export function* deletePartenaireAcadSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/partenaires-academiques/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setPartenairesAcadLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deletePartenaireAcadSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Partenaire académique supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression partenaire";
        yield put(deletePartenaireAcadFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setPartenairesAcadLoading(false));
    }



}
